import { useEffect } from "react";
import { useLocation, matchPath } from "react-router-dom";
import { routes } from "../routes";

function flattenRoutes(routesArray) {
  let result = [];

  routesArray.forEach((route) => {
    if (route.routes) {
      result = [...result, ...flattenRoutes(route.routes)];
    } else {
      result.push(route);
    }
  });

  return result;
}

export default function PageTitleManager() {
  const location = useLocation();

  useEffect(() => {
    const allRoutes = flattenRoutes(routes);

    const currentRoute = allRoutes.find((route) =>
      matchPath(
        {
          path: route.path,
          end: true,
        },
        location.pathname
      )
    );

    document.title = currentRoute?.title
      ? `${currentRoute.title} - KyanUp`
      : "KyanUp";
  }, [location.pathname]);

  return null;
}